module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/175b4656e28f6827b1972260c13c1ceb.png";